import React from 'react';

function SchoolLeader() {
  const leaders = [
    { title: 'School Pupil Leader', name: 'Student Name', house: 'Leadership', color: '#1e3a8a', image: '/images/school-cabinet/pupil-leader.svg' },
    { title: 'Assistant School Pupil Leader', name: 'Student Name', house: 'Leadership', color: '#7c3aed', image: '/images/school-cabinet/asst-pupil-leader.svg' }
  ];

  const houseCaptains = [
    { house: 'Blue House', captain: 'Student Name', color: '#3b82f6', image: '/images/school-cabinet/captain-blue.svg' },
    { house: 'Green House', captain: 'Student Name', color: '#10b981', image: '/images/school-cabinet/captain-green.svg' },
    { house: 'Yellow House', captain: 'Student Name', color: '#f59e0b', image: '/images/school-cabinet/captain-yellow.svg' },
    { house: 'Red House', captain: 'Student Name', color: '#ef4444', image: '/images/school-cabinet/captain-red.svg' }
  ];

  return (
    <section style={{background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)', paddingTop: '160px', paddingBottom: '80px', minHeight: '100vh'}}>
      <div className="container">
        <h2 style={{fontSize: '3.5rem', textAlign: 'center', marginBottom: '20px', color: '#0c4a6e', fontWeight: 900}}>School Cabinet</h2>
        <p style={{fontSize: '1.3rem', textAlign: 'center', marginBottom: '60px', color: '#0369a1'}}>Our student leaders who inspire and guide their peers</p>
        
        {/* School Pupil Leaders */}
        <div style={{marginBottom: '80px'}}>
          <h3 style={{fontSize: '2.5rem', textAlign: 'center', marginBottom: '40px', color: '#0c4a6e', fontWeight: 800}}>Student Leadership</h3>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 300px), 1fr))', gap: '40px', maxWidth: '900px', margin: '0 auto'}}>
            {leaders.map((leader, i) => (
              <div key={i} style={{background: `linear-gradient(135deg, ${leader.color} 0%, ${leader.color}dd 100%)`, padding: '0', borderRadius: '25px', boxShadow: '0 15px 40px rgba(0,0,0,0.2)', overflow: 'hidden', transition: 'transform 0.3s'}}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                <div style={{padding: '40px', textAlign: 'center'}}>
                  <img src={leader.image} alt={leader.title} style={{width: '250px', height: '250px', borderRadius: '50%', objectFit: 'cover', border: '5px solid white', marginBottom: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.3)'}} />
                </div>
                <div style={{background: 'white', padding: '30px', textAlign: 'center'}}>
                  <h4 style={{fontSize: '1.6rem', color: leader.color, fontWeight: 700, marginBottom: '10px'}}>{leader.title}</h4>
                  <p style={{fontSize: '1.3rem', color: '#1e293b', fontWeight: 600}}>{leader.name}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* House Captains */}
        <div>
          <h3 style={{fontSize: '2.5rem', textAlign: 'center', marginBottom: '40px', color: '#0c4a6e', fontWeight: 800}}>House Captains</h3>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 280px), 1fr))', gap: '30px'}}>
            {houseCaptains.map((house, i) => (
              <div key={i} style={{background: 'white', padding: '35px', borderRadius: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', textAlign: 'center', border: `4px solid ${house.color}`, transition: 'transform 0.3s'}}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                <div style={{width: '80px', height: '80px', background: house.color, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px', fontSize: '2.5rem', color: 'white'}}>
                  <i className="fas fa-shield-alt"></i>
                </div>
                <img src={house.image} alt={house.house} style={{width: '200px', height: '200px', borderRadius: '50%', objectFit: 'cover', border: `4px solid ${house.color}`, marginBottom: '20px'}} />
                <h4 style={{fontSize: '1.6rem', color: house.color, fontWeight: 700, marginBottom: '10px'}}>{house.house}</h4>
                <p style={{fontSize: '1.1rem', color: '#64748b', fontWeight: 600}}>Captain</p>
                <p style={{fontSize: '1.2rem', color: '#1e293b', fontWeight: 700}}>{house.captain}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default SchoolLeader;
